import { getLivestreamSection } from "../../api/erp";

export const loadLiveEditor = () => import("../../components/business/forms/Live").then(module => ({ default: module.EditLiveDrawer }));

/** All entry points use the same narrow read and load code concurrently. */
export async function readLiveEditor(id: number, signal?: AbortSignal, section: 'information' | 'sessions' = 'information') {
    const [session] = await Promise.all([getLivestreamSection(id, section, signal), loadLiveEditor()]);
    return {sessions:[], description:'', product_pitch_script:'', ...session} as import("../../api/erp").ApiLivestreamEdit;
}
